import React, { useState, useCallback } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  Chip,
  TextField,
  Box,
  TextareaAutosize,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import t from "../common/localization";
import { useEffectAsync } from "../reactHelper";
import EditCollectionView from "../EditCollectionView";
import { formatBoolean, formatPosition, formatDate } from "../common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { green, blue, red, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";
// import PersonIcon from "@material-ui/icons/Person";
import LocalTaxiIcon from "@material-ui/icons/LocalTaxi";
import { debounce, set } from "lodash";
import { DataGrid, GridAddIcon } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    display: "flex",
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 688,
  },
}));

const UsersView = ({
  updateTimestamp,
  onMenuClick,
  handleOnEdit,
  handleOnRemove,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const operatingUser = useSelector((state) => state.session.user);
  const prepaidUser = operatingUser.prepaid;
  const adminEnabled = operatingUser.administrator;
  const distributorEnabled = operatingUser.distributor;
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [userDevices, setUserDevices] = useState([]);
  const [isShowDevices, setIsShowDevices] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const [isShowAddPoints, setIsShowAddPoints] = useState(false);
  const [addPoints, setAddPoints] = useState(0);
  const [rate, setRate] = useState(0);
  const [remarks, setRemarks] = useState("");
  
  const [isShowCredit, setIsShowCredit] = useState(false);
  const [vendor, setVendor] = useState({});
  const [addAccountBalance, setAddAccountBalance] = useState(0);
  const [deviceRate, setDeviceRate] = useState();
  const [selectedType, setSelectedType] = useState("CREDIT");

  const getResult = async (val) => {
    dispatch(showLoaderStateActions.addState(true));
    const data = { search: val, page: 0, size: 50 };

    const response = await fetch("/api/android/searchUser", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };
  const debounceFn = useCallback(debounce(getResult, 1500), []);

  const getAllList = async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/users");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };

  const searchChange = (val) => {
    if (val && val.length > 3) {
      debounceFn(val);
    }
  };

  const reset = () => {
    console.log("val");
  };

  const showDevices = async (user) => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch(`/api/devices?userId=${user.value.id}`);
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setUserDevices(res);
    }
    setIsShowDevices(true);
  };
  const handleClose = () => {
    setIsShowDevices(false);
    setIsShowAddPoints(false);
    setIsShowCredit(false);
  };

  const handleAddPoints = async (user) => {
    setIsShowAddPoints(true);
    setSelectedUser(user);
  }

  const handlePointAddSubmit = async () =>{
    const data = {
      "attributes": {
          "remarks": remarks
      },
      "devicePointRate": rate,
      "devicePoints": addPoints,
      "userId": selectedUser["id"]
    }
    
    const response = await fetch("/api/users/updateUserDevicePoints", {
      method: "PUT",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();

    if (response.ok) {
      setIsShowAddPoints(false);
      setAddPoints(0);
      setRate(0);
      setRemarks(0);
      setSearchList([]);
    }
  }

  const showCredit = async (user) => {
    setSelectedUser(user);
    setIsShowCredit(true);
    const response = await fetch(`/api/vendorAccount/getByUser/${user["id"]}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    setVendor(result);
    setDeviceRate(result.deviceRate);
    // setPrevAccountBalance(result.accountBalance);
    // setPrevDeviceRate(result.deviceRate);
    // setVendorId(result.id);
  }

  const handleAmountAddSubmit = async () => {
    if(addAccountBalance != 0 && addAccountBalance <= 10000){
      const dataAccountBalance = {
        "id": vendor["id"],
        "amount": addAccountBalance,
        "remarks": remarks,
        "transactionType": selectedType,
      }
      
      const responseAccountBalance = await fetch("/api/vendorAccount/transactAccount", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataAccountBalance),
      });
    }

    
    if(vendor["deviceRate"] != deviceRate && deviceRate >= 0.4 && deviceRate <= 5){
      const dataDeviceRate = {
        ...vendor,
        "deviceRate": deviceRate,
      }

      const responseDeviceRate = await fetch("/api/vendorAccount/"+vendor["id"], {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataDeviceRate),
      });
    }

    setAddAccountBalance(0);
    setSelectedType("CREDIT");
    setDeviceRate(0);
    setRemarks("");
    showCredit(selectedUser);
  }

  const handleOnRenew = async (user) => {
    if(confirm("Do You Want To Extend User Expiry!")){
      dispatch(showLoaderStateActions.addState(true));

      const payload = {
        deviceId: 0,
        userId: user
      }
      console.log(payload);
      const response = await fetch("/api/users/extendUserExpirationTime",{
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
          },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const result = await response.json();
        setSearchList([]);
        alert("Expiry Extended Success Fully!")
      }
      dispatch(showLoaderStateActions.addState(false));
    }
  }

  const filterItems = searchList.filter(
    (current) => current.id !== operatingUser.id
  );

  filterItems.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()
  );

  const columns = [
    { field: "name", headerName: t("userName"), width: 180 },
    { field: "username", headerName: t("username"), width: 150 },
    { field: "email", headerName: t("userEmail"), width: 150 },
    { field: "phone", headerName: t("sharedPhone"), width: 120 },
    ...(adminEnabled ? [{ field: "userAdmin", headerName: t("userAdmin"), width: 150 }] : []),
    { field: "creationTime", headerName: t("userCreationDate"), width: 150 },
    { field: "expirationTime", headerName: t("userExpiryDate"), width: 150 },
    ...((adminEnabled || distributorEnabled)
    ? [
      prepaidUser
      ? {
        field: "devicePoints",
        headerName: "Points",
        width: 200,
        renderCell: (params) => (
          <Box display="flex" alignItems="center" gap={1}>
                      <Chip label={params.value} variant="outlined" />
                      {params.value !== "N/A" && (
                        <Avatar className={classes.small}>
                          <IconButton onClick={() => handleAddPoints(params.row.attachedDevices)}>
                            <GridAddIcon fontSize="small" style={{ color: blue[600] }} />
                          </IconButton>
                        </Avatar>
                      )}
                    </Box>
                  ),
                }
                : {
                  field: "accountBalance",
                  headerName: "Credit",
                  width: 150,
                  renderCell: (params) => (
                    <Box display="flex" alignItems="center" gap={1}>
                      {params.value !== "N/A" ? (
                        <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => showCredit(params.row.accountBalance)}
                        >
                          Show Credit
                        </Button>
                      ) : (
                        <Chip label={params.value} variant="outlined" />
                      )}
                    </Box>
                  ),
                },
              ]
              : []
            ),
      { field: "attachedDevices", headerName: "Attached Device", width: 150, 
              renderCell: (params)=><>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            showDevices(params);
          }}
          >
          Show devices
        </Button>
      </>
     },
     { field: "action", headerName: "Action", width: 250, 
      renderCell: (params)=><>
      <div className={classes.iconButtons}>
        {prepaidUser &&
          <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOnRenew(params.value);
          }}
          >
            Extend Expiry
          </Button>
        }
        <Avatar className={classes.small}>
          {
            <IconButton onClick={(event) => handleOnEdit(params.value)}>
              <EditIcon
                fontSize="small"
                style={{ color: blue[600] }}
                />
            </IconButton>
          }
        </Avatar>
        <Avatar className={classes.small}>
          {
            <IconButton
            onClick={(event) => handleOnRemove(params.value)}
            >
              <ClearIcon
                fontSize="small"
                style={{ color: grey[450] }}
                />
            </IconButton>
          }
        </Avatar>
      </div>
      </>
     },
     { field: "sharedDisabled", headerName: t("sharedDisabled"), width: 150 },
    ];
    
    const gridRows = filterItems.map((item, index) => ({
      id: index, // required unique id for DataGrid
    name: item.name,
    username: item.username,
    email: item.email,
    phone: item.phone,
    creationTime: formatDate(item.creationTime),
    expirationTime: formatDate(item.expirationTime),
    ...(adminEnabled ? {userAdmin: formatPosition(item, "administrator")} : []),
    devicePoints: (item.deviceLimit < 1)? "N/A" : (item.devicePoints),
    accountBalance: (item.deviceLimit < 1)? "N/A" : (item),
    sharedDisabled: formatPosition(item, "disabled"),
    attachedDevices: item,
    action: item.id,
  }));

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isShowDevices}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="simple-dialog-title">
        Attached Vehicle List
        </DialogTitle>
        <DialogContent>
          {!userDevices.length ? (
            <div> No Vehicle Attached !!</div>
          ) : (
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Vehicle Number</TableCell>
                    <TableCell align="right">IMEI</TableCell>
                    <TableCell align="right">VTS Number</TableCell>
                    <TableCell align="right">Device Model</TableCell>
                    <TableCell align="right">Expiry Date</TableCell>
                    <TableCell align="right">Status</TableCell>
                    <TableCell align="right">Last Update</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userDevices.map((device) => (
                    <TableRow key={device.name}>
                      <TableCell component="th" scope="row">
                        {device.name}
                      </TableCell>
                      <TableCell align="right">{device.uniqueId}</TableCell>
                      <TableCell align="right">{device.phone}</TableCell>
                      <TableCell align="right">{device.model}</TableCell>
                      <TableCell align="right">
                        {formatDate(device.expirationTime, "MMM D, YYYY")}
                      </TableCell>
                      <TableCell align="right">{device.status}</TableCell>
                      <TableCell align="right">
                        {formatDate(device.lastUpdate, "MMM D, YYYY")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>

      {/* Add Points Dialog Box */}

      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isShowAddPoints}
        maxWidth="md"
      >
        <DialogTitle id="simple-dialog-title">
          Add Points
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            autoComplete="off"
          >

            <TextField 
              label="Add Points" 
              fullWidth={true}
              value={addPoints}
              type="number"
              inputProps={{ min: 0 }}
              onChange={(e)=>{
                setAddPoints(e.target.value);
              }}
            />
            <br />
            <br />
            <TextField 
              label="Rate" 
              fullWidth={true}
              value={rate}
              type="number"
              inputProps={{ min: 0 }}
              onChange={(e)=>{
                setRate(e.target.value);
              }}
            />
            <br />
            <br />
            <TextareaAutosize 
              placeholder="Remarks" 
              fullWidth={true}
              value={remarks}
              minRows={3}
              style={{ width: 300 }}
              onChange={(e)=>{
                setRemarks(e.target.value);
              }}
            />
            <br />
            <br />
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: 16 }}
                fullWidth
                onClick={handlePointAddSubmit}
            >
                Submit
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Show Credit Dialog Box */}

      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isShowCredit}
        maxWidth="md"
      >
        <DialogTitle id="simple-dialog-title">
          Account Balance: {vendor["accountBalance"]}
          <br/>
          Device Rate: {vendor["deviceRate"]}
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            autoComplete="off"
          >

            <FormControl fullWidth margin="normal">
                <InputLabel>Transaction Type</InputLabel>
                <Select value={selectedType} onChange={(e) => {setSelectedType(e.target.value)}}>
                    <MenuItem value="CREDIT">Credit</MenuItem>
                    <MenuItem value="DEBIT">Debit</MenuItem>
                </Select>
            </FormControl>
            <br />
            <br />
            <TextField 
              label="Amount" 
              fullWidth={true}
              value={addAccountBalance}
              type="number"
              inputProps={{ min: 0, max: 10000}}
              onChange={(e)=>{
                setAddAccountBalance(e.target.value);
              }}
            />
            <br />
            <br />
            <TextField 
              label="Device Rate (Rs/vehicle/day)" 
              fullWidth={true}
              value={deviceRate}
              type="number"
              inputProps={{ min: 0.4, max: 5, step: "any" }}
              onChange={(e)=>{
                setDeviceRate(e.target.value);
              }}
            />
            <br />
            <br />
            <TextareaAutosize 
              placeholder="Remarks" 
              fullWidth={true}
              value={remarks}
              minRows={3}
              style={{ width: 300 }}
              onChange={(e)=>{
                setRemarks(e.target.value);
              }}
            />
            <br />
            <br />
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: 16 }}
                fullWidth
                onClick={handleAmountAddSubmit}
            >
                Submit
            </Button>
          </Box>
        </DialogContent>
      </Dialog>


      <div style={{ marginBottom: "10px", display: "flex" }}>
        <SearchBar
          onChange={searchChange}
          onCancelSearch={reset}
          placeholder="Search here..."
          className="searchBarInput"
          style={{
            borderRadius: 15,
            height: 35,
            boxShadow: "2px 2px 2px 2px #dbddef",
            fontSize: 12,
            width: "300px",
          }}
        />
        <Button
          variant="outlined"
          style={{ marginLeft: "10px" }}
          color="primary"
          onClick={getAllList}
        >
          Show All Users
        </Button>
      </div>

      {/* <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          style={{ whiteSpace: "nowrap" }}
          className={classes.tableAction}
          size="small"
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>{t("userName")}</TableCell>
              <TableCell className={classes.tCell}>{t("username")}</TableCell>
              <TableCell className={classes.tCell}>{t("userEmail")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("sharedPhone")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("userCreationDate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("userExpiryDate")}
              </TableCell>
              {adminEnabled && (
                <TableCell className={classes.tCell}>
                  {t("userAdmin")}
                </TableCell>
              )}
              <TableCell className={classes.tCell}>
                {t("sharedDisabled")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {"Attached Device"}
              </TableCell>

              <TableCell className={classes.tCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {filterItems.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.name}</b>}</TableCell>
                <TableCell>{item.username}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{item.phone}</TableCell>
                <TableCell>
                  {formatDate(item.creationTime, "MMM D, YYYY")}
                </TableCell>
                <TableCell>
                  {formatDate(item.expirationTime, "MMM D, YYYY")}
                </TableCell>
                {adminEnabled && (
                  <TableCell>{formatPosition(item, "administrator")}</TableCell>
                )}
                <TableCell>{formatPosition(item, "disabled")}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      showDevices(item);
                    }}
                  >
                    Show devices
                  </Button>
                </TableCell>

                <TableCell className={classes.columnAction} padding="none">
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={(event) => handleOnEdit(item.id)}>
                          <EditIcon
                            fontSize="small"
                            style={{ color: blue[600] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                    <Avatar className={classes.small}>
                      {
                        <IconButton
                          onClick={(event) => handleOnRemove(item.id)}
                        >
                          <ClearIcon
                            fontSize="small"
                            style={{ color: grey[450] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}

      <DataGrid
        rows={gridRows}
        columns={columns}
        disableSelectionOnClick
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        pagination
      />
    </>
  );
};

const UsersPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={UsersView}
        editPath="/user"
        endpoint="users"
        successDialogShow={false}
      />
    </>
  );
};

export default UsersPage;
